@if (documentComplete && documentComplete.versions.length > 0) {
	<it-card>
		<h3 class="it-card-title it-card-title-icon h5">
			<span>
				{{ documentComplete.title }}
				@if (!isFromDifferentAuthority) {
					<button
						type="button"
						itButton="link"
						[disabled]="progressDeleteDocument"
						(click)="editDocumentModal.toggle()"
					>
						<it-icon
							name="pencil"
							[title]="'it.general.edit' | translate"
						></it-icon>
					</button>
					<button
						class="btn-icon"
						type="button"
						itButton="link"
						[disabled]="progressDeleteDocument"
						[progress]="progressDeleteDocument"
						(click)="deleteDocument.emit(documentComplete)"
					>
						<it-icon
							name="delete"
							color="danger"
							[title]="'iterlex.delete-document' | translate"
						></it-icon>
					</button>
				}
			</span>
			<div class="it-card-title-icon-wrapper">
				@if (documentComplete.hierarchy === "main") {
					<it-icon name="files"></it-icon>
				} @else {
					<it-icon name="clip"></it-icon>
				}
			</div>
		</h3>
		<div class="it-card-body">
			<p class="it-card-text">
				@if (documentTypes) {
					@if (
						currentPhase.id.includes("condivisione") &&
						documentComplete.aliases.length > 1
					) {
						{{
							getDocumentTypeLabel(
								documentComplete.aliases[0].uri
							)
						}}
						→
					}
					{{ getDocumentTypeLabel() }}
				}
				<br />{{ "iterlex.number" | translate }}
				@if (
					currentPhase.id.includes("condivisione") &&
					documentComplete.aliases.length > 1
				) {
					{{ documentComplete.aliases[0].number }} →
				}
				{{ getDocumentNumber() }}
			</p>
			<p class="card-text">
				@for (
					version of documentComplete.versions;
					track version.expressionUri
				) {
					<it-accordion
						[title]="
							((version.date | date: 'd/M/yyyy HH:mm') ??
								version.date) +
							' ' +
							(version.language | uppercase)
						"
					>
						<app-files
							[authority]="authority"
							[body]="body"
							[dossier]="dossier"
							[documentComplete]="documentComplete"
							[version]="version"
							[phase]="currentPhase"
							[step]="currentStep"
							[showChangeActions]="!isFromDifferentAuthority"
							(updateFileList)="updateDocumentComplete()"
						></app-files>
						@if (!isFromDifferentAuthority) {
							<button
								type="button"
								itButton="outline-primary"
								[disabled]="
									progressDeleteVersionUri ===
									version.expressionUri
								"
								size="xs"
								(click)="
									getPhasesAndSteps();
									getVersionSteps(version.expressionUri);
									currentExpressionUri =
										version.expressionUri;
									moveVersionModal.toggle()
								"
							>
								{{ "iterlex.select-steps" | translate }}
							</button>
							<button
								type="button"
								itButton="outline-danger"
								[disabled]="
									progressDeleteVersionUri ===
									version.expressionUri
								"
								[progress]="
									progressDeleteVersionUri ===
									version.expressionUri
								"
								size="xs"
								(click)="deleteVersionModal.toggle()"
							>
								{{ "iterlex.delete-version" | translate }}
							</button>
						}
						<it-modal
							#deleteVersionModal
							closeButton="false"
							popconfirm="true"
						>
							<ng-container modalTitle>{{
								"iterlex.delete-version-confirm" | translate
							}}</ng-container>
							<p>
								{{
									"iterlex.delete-version-confirm-description"
										| translate
											: {
													name:
														((version.date
															| date
																: "d/M/yyyy HH:mm") ??
															version.date) +
														" " +
														(version.language
															| uppercase),
											  }
								}}
							</p>
							<ng-container footer>
								<button
									itButton="danger"
									type="button"
									data-bs-dismiss="modal"
									(click)="
										deleteVersion(version.expressionUri)
									"
								>
									{{ "it.core.remove" | translate }}
								</button>
								<button
									itButton="outline-secondary"
									type="button"
									data-bs-dismiss="modal"
								>
									{{ "iterlex.cancel" | translate }}
								</button>
							</ng-container>
						</it-modal>
					</it-accordion>
				}
			</p>
			@if (isFromDifferentAuthority) {
				<button
					type="button"
					itButton="primary"
					size="xs"
					(click)="createAliasModal.toggle()"
				>
					{{ "iterlex.import" | translate }}
				</button>
			} @else {
				<button
					type="button"
					itButton="primary"
					size="xs"
					(click)="createVersionModal.toggle()"
				>
					{{ "iterlex.create-version" | translate }}
				</button>
			}
			@if (documentComplete.hierarchy === "main") {
				<button
					type="button"
					itButton="primary"
					class="ms-2"
					size="xs"
					(click)="createAttachmentModal.toggle()"
				>
					{{ "iterlex.create-attachment" | translate }}
				</button>
				<it-modal #createAttachmentModal>
					<ng-container modalTitle>{{
						"iterlex.create-attachment" | translate
					}}</ng-container>
					<form
						#newAttachmentForm="ngForm"
						(ngSubmit)="onCreateAttachmentSubmit(newAttachmentForm)"
					>
						<it-select
							name="documentSubtype"
							[label]="'iterlex.document-subtype' | translate"
							[ngModel]="
								documentComplete.workUri.split('/')[3] +
								'/' +
								documentComplete.workUri.split('/')[4]
							"
							required
						>
							<option selected value="">
								{{
									"iterlex.select-document-subtype"
										| translate
								}}
							</option>
							@for (
								documentType of documentTypes;
								track documentType.id
							) {
								@for (
									documentSubtype of documentType.subtypes;
									track documentSubtype.id
								) {
									<option
										[value]="
											documentType.id +
											'/' +
											documentSubtype.id
										"
									>
										{{
											documentSubtype.label[
												"iterlex.currentLanguage"
													| translate
											]
										}}
									</option>
								}
							}
						</it-select>
						<it-input
							type="text"
							name="title"
							ngModel
							required
							[label]="'iterlex.title' | translate"
						></it-input>
						<it-input
							type="text"
							name="number"
							[ngModel]="documentComplete.number"
							required
							[label]="'iterlex.number' | translate"
						></it-input>
						<it-select
							name="language"
							[label]="'iterlex.language' | translate"
							[ngModel]="documentComplete.versions[0].language"
							required
						>
							<option selected value="">
								{{ "it.utils.select-language" | translate }}
							</option>
							@for (language of languages; track language) {
								<option [value]="language">
									{{ "iterlex." + language | translate }}
								</option>
							}
						</it-select>
						<it-input
							type="date"
							name="date"
							[ngModel]="documentComplete.date.substring(0, 10)"
							required
							[label]="'iterlex.date' | translate"
						></it-input>
						<it-input
							type="time"
							name="time"
							[ngModel]="
								documentComplete.versions[0].date.substring(
									11,
									16
								)
							"
							required
							[label]="'iterlex.time' | translate"
							ngModel="00:00"
						></it-input>
						<button
							itButton="primary"
							type="submit"
							size="xs"
							[disabled]="!newAttachmentForm.valid"
							data-bs-dismiss="modal"
						>
							{{ "iterlex.create-attachment" | translate }}
						</button>
					</form>
					<ng-container footer><span></span></ng-container>
				</it-modal>
				@for (attachment of attachments; track attachment.workUri) {
					<div class="p-2">
						<app-document
							[currentPhase]="currentPhase"
							[currentStep]="currentStep"
							[authority]="authority"
							[body]="body"
							[documentTypes]="documentTypes"
							[dossier]="dossier"
							[document]="attachment"
							(setCurrentPhaseEvent)="
								setCurrentPhaseEvent.emit($event)
							"
							(deleteDocument)="deleteDocument.emit(attachment)"
							(refreshDocuments)="this.updateDocumentComplete()"
						/>
					</div>
				}
			}
		</div>
	</it-card>
	<it-modal #editDocumentModal>
		<ng-container modalTitle>{{
			"it.general.edit" | translate
		}}</ng-container>
		<form
			#editDocumentForm="ngForm"
			(ngSubmit)="onEditDocumentSubmit(editDocumentForm)"
		>
			<it-input
				type="text"
				name="title"
				ngModel
				required
				[label]="'iterlex.title' | translate"
				[ngModel]="documentComplete.title"
			></it-input>
			<button
				itButton="primary"
				type="submit"
				[disabled]="!editDocumentForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "it.general.save" | translate }}
			</button>
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
	<it-modal #createVersionModal>
		<ng-container modalTitle>{{
			"iterlex.create-version" | translate
		}}</ng-container>
		<form
			#newVersionForm="ngForm"
			(ngSubmit)="onCreateVersionSubmit(newVersionForm)"
		>
			<it-input
				type="date"
				name="date"
				ngModel
				required
				[label]="'iterlex.date' | translate"
			></it-input>
			<it-input
				type="time"
				name="time"
				ngModel
				required
				[label]="'iterlex.time' | translate"
				ngModel="00:00"
			></it-input>
			<it-select
				name="language"
				[label]="'iterlex.language' | translate"
				ngModel
				required
			>
				<option selected value="">
					{{ "it.utils.select-language" | translate }}
				</option>
				@for (language of languages; track language) {
					<option [value]="language">
						{{ "iterlex." + language | translate }}
					</option>
				}
			</it-select>
			<div class="form-group">
				<input
					type="file"
					name="file"
					ngModel
					(change)="setCurrentFile($event.target.files)"
				/>
			</div>
			<button
				itButton="primary"
				type="submit"
				size="xs"
				[disabled]="!newVersionForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.create-version" | translate }}
			</button>
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
	<it-modal #moveVersionModal>
		<ng-container modalTitle>{{
			"iterlex.select-steps" | translate
		}}</ng-container>
		<form
			#moveVersionForm="ngForm"
			(ngSubmit)="onMoveVersionSubmit(moveVersionForm)"
		>
			@if (phases.length === 0) {
				<p>{{ "it.core.loading" | translate }}</p>
			} @else {
				<div class="form-group">
					@for (phase of phases; track phase.id) {
						<it-accordion
							[title]="
								phase.label[
									'iterlex.currentLanguage' | translate
								]
							"
						>
							@if (!steps[phase.id]) {
								<p>{{ "it.core.loading" | translate }}</p>
							}
							@for (step of steps[phase.id]; track step.id) {
								<it-checkbox
									[checked]="currentSteps.includes(step.id)"
									[disabled]="currentStep.id === step.id"
									[label]="
										step.label[
											'iterlex.currentLanguage'
												| translate
										]
									"
									(click)="changeStep(phase.id, step.id)"
								></it-checkbox>
							}
						</it-accordion>
					}
				</div>
				<button
					itButton="primary"
					type="submit"
					data-bs-dismiss="modal"
				>
					{{ "it.general.save" | translate }}
				</button>
			}
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
	<it-modal #createAliasModal>
		<ng-container modalTitle>{{
			"iterlex.import" | translate
		}}</ng-container>
		<form
			#createAliasForm="ngForm"
			(ngSubmit)="onCreateAliasSubmit(createAliasForm)"
		>
			<it-select
				name="documentSubtype"
				[label]="'iterlex.document-subtype' | translate"
				ngModel
				required
				[ngModel]="
					documentComplete.workUri.split('/')[3] +
					'/' +
					documentComplete.workUri.split('/')[4]
				"
			>
				<option selected value="">
					{{ "iterlex.select-document-subtype" | translate }}
				</option>
				@for (documentType of documentTypes; track documentType.id) {
					@for (
						documentSubtype of documentType.subtypes;
						track documentSubtype.id
					) {
						<option
							[value]="documentType.id + '/' + documentSubtype.id"
						>
							{{
								documentSubtype.label[
									"iterlex.currentLanguage" | translate
								]
							}}
						</option>
					}
				}
			</it-select>
			<it-input
				type="text"
				name="number"
				ngModel
				required
				[label]="'iterlex.number' | translate"
			></it-input>
			<it-input
				type="date"
				name="date"
				ngModel
				required
				[label]="'iterlex.date' | translate"
			></it-input>
			<button
				itButton="primary"
				type="submit"
				[disabled]="!createAliasForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.import" | translate }}
			</button>
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
}
